import request from '@/utils/requestSocketApi'

export function getSocketInfo(query) {
  return request({
    url: '/Unity/getSocketInfo',
    method: 'get',
    params: query,
  })
}
// export function saveAgency(data) {
//   return request({
//     url: '/Agency/saveAgency',
//     method: 'post',
//     data
//   })
// }
